export const labelListCodes = {
  JobPriorities: 'JP',
}
